import { Injectable, inject } from "@angular/core";

import { ApiService } from "../api.service";

@Injectable({
	providedIn: "root",
})
export class NotificationService {
	private apiService = inject(ApiService);

	messages: any[] = [];
	messagesFetched: boolean = false;

	getMessages = () => {
		if (!this.messagesFetched) {
			return this.fetchMessages();
		} else {
			return new Promise((resolve, _) => {
				resolve(this.messages);
			});
		}
	};

	getMessage = (id: string) => {
		return this.getMessages().then((messages: any) => {
			return messages.find((message: any) => message.Id === id);
		});
	};

	getUnreadMessagesCount = () => {
		return this.getMessages().then((messages: any) => {
			const unreadMessages = messages.filter((message: any) => message.IsNew);

			return unreadMessages.length;
		});
	};

	setMessageToRead = (id: string) => {
		this.apiService.SetMessageAsRead(id).then(() => {
			this.messages.forEach((message: any) => {
				if (message.Id == id) {
					message.IsNew = false;
				}
			});
		});
	};

	private fetchMessages = () => {
		return this.apiService.GetUserMessages().then((messages: any) => {
			this.messages = messages;
			this.messagesFetched = true;
			return this.messages;
		});
	};
}
